import React, { useEffect, useState } from "react";
import { InlineWidget } from "react-calendly";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import CommonDialog from "./CommonDialog";
import { showNotification } from "./Notification/ToastifyNotification";
import { bookSessionDirect } from "../../api/sessionApi";

export default function CommonBookSession({
  bookingUrl,
  open,
  studentName,
  email,
  tutorName,
  mentorProfileId,
  handleClose,
  setOpen
}) {
  const navigate = useNavigate();
  const [bookingError, setBookingError] = useState(null);
  const [lastPayload, setLastPayload] = useState(null);

  useEffect(() => {
    if (open) {
      setBookingError(null);
      setLastPayload(null);
    }
  }, [open]);

  const confirmMentorSession = async (payload) => {
    try {
      await bookSessionDirect(payload);
      setBookingError(null);
      setLastPayload(null);
      showNotification('Your session has been booked', 'success');
      setOpen(false);
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error || "We couldn't save your session. Please try again or contact support.";
      setBookingError(errorMessage);
      setLastPayload(payload);
      showNotification(errorMessage, 'error');
    }
  };

  useEffect(() => {
    function handleCalendlyEvent(e) {
      if (e.data.event === "calendly.event_scheduled" || e.data.event === "calendly.event_rescheduled") {
        if (mentorProfileId) {
          confirmMentorSession({
            mentor_profile_id: mentorProfileId,
            calendly_invitee_uri: e.data.payload?.invitee?.uri,
            calendly_event_uri: e.data.payload?.event?.uri,
          });
        } else if (handleClose) {
          handleClose(e.data);
        } else {
          navigate(`/intake-form?uri=${e.data.payload?.invitee?.uri}`);
        }
      }
    }

    window.addEventListener("message", handleCalendlyEvent);

    return () => {
      window.removeEventListener("message", handleCalendlyEvent);
    };
  }, [navigate, mentorProfileId]);

  return (
    <CommonDialog
      open={open}
      onClose={() => setOpen(false)}
      content={
        <>
          {bookingError && (
            <Box
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 1,
                backgroundColor: '#FEF2F2',
                color: '#B91C1C',
                fontSize: 14,
              }}
            >
              {bookingError}
            </Box>
          )}
          <InlineWidget
            url={bookingUrl}
            prefill={{
              name: studentName,
              email: email,
              ...(tutorName ? { customAnswers: { a1: tutorName } } : {}),
            }}
          />
        </>
      }
      actionButtons={
        bookingError ? (
          <>
            <Button
              onClick={() => {
                setOpen(false);
                navigate('/my-contact-support');
              }}
            >
              Contact Support
            </Button>
            <Button
              variant="contained"
              onClick={() => lastPayload && confirmMentorSession(lastPayload)}
            >
              Retry
            </Button>
          </>
        ) : null
      }
    />
  );
}
